/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_OptionExercise_CalculateExerciseRequestDto } from '../models/Wealthlane_AwardService_Dtos_OptionExercise_CalculateExerciseRequestDto';
import type { Wealthlane_AwardService_Dtos_OptionExercise_CalculateExerciseResponseDto } from '../models/Wealthlane_AwardService_Dtos_OptionExercise_CalculateExerciseResponseDto';
import type { Wealthlane_AwardService_Dtos_OptionExercise_OptionExerciseListDto } from '../models/Wealthlane_AwardService_Dtos_OptionExercise_OptionExerciseListDto';
import type { Wealthlane_AwardService_Dtos_OptionExercise_StatusDto } from '../models/Wealthlane_AwardService_Dtos_OptionExercise_StatusDto';
import type { Wealthlane_AwardService_Dtos_OptionExercise_UpdateTaxesDto } from '../models/Wealthlane_AwardService_Dtos_OptionExercise_UpdateTaxesDto';
import type { Wealthlane_AwardService_Dtos_Transactions_ElectionHistoryDto } from '../models/Wealthlane_AwardService_Dtos_Transactions_ElectionHistoryDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class OptionExerciseSharedService {

    /**
     * @param awardId
     * @returns Wealthlane_AwardService_Dtos_Transactions_ElectionHistoryDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppOptionExerciseExerciseListByAwardId(
        awardId: string,
    ): CancelablePromise<Array<Wealthlane_AwardService_Dtos_Transactions_ElectionHistoryDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/option-exercise/exercise-list-by-award-id/{AwardId}',
            path: {
                'AwardId': awardId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns Wealthlane_AwardService_Dtos_OptionExercise_CalculateExerciseResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppOptionExerciseCalculateExercise(
        requestBody?: Wealthlane_AwardService_Dtos_OptionExercise_CalculateExerciseRequestDto,
    ): CancelablePromise<Wealthlane_AwardService_Dtos_OptionExercise_CalculateExerciseResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/option-exercise/calculate-exercise',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param awardType
     * @returns Wealthlane_AwardService_Dtos_OptionExercise_OptionExerciseListDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppOptionExerciseExercisableAwards(
        awardType?: string,
    ): CancelablePromise<Array<Wealthlane_AwardService_Dtos_OptionExercise_OptionExerciseListDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/option-exercise/exercisable-awards',
            query: {
                'awardType': awardType,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_OptionExercise_StatusDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppOptionExerciseSettlementTypes(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_OptionExercise_StatusDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/option-exercise/settlement-types',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param transactionId
     * @returns Wealthlane_AwardService_Dtos_OptionExercise_UpdateTaxesDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppOptionExerciseTaxDetailsByTransactionId(
        transactionId: string,
    ): CancelablePromise<Wealthlane_AwardService_Dtos_OptionExercise_UpdateTaxesDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/option-exercise/tax-details-by-transaction-id/{TransactionId}',
            path: {
                'TransactionId': transactionId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
